<template>
  <section class="accordion">
    <h2
      v-if="accordionTitle"
      class="accordion-title"
    >
      {{ accordionTitle }}
    </h2>
    <p
      v-if="accordionIntro"
      class="accordion-intro"
    >
      {{ accordionIntro }}
    </p>
    <kf-accordion-item
      v-for="item in accordionItems"
      :id="item.anchorId || item.key"
      :key="item.key"
      :title="item.question"
      :title-link="item.titleLink"
      :title-link-label="item.titleLinkLabel"
      :is-initially-open="(item.anchorId !== '' && item.anchorId === preselectedItemKey) || item.key === preselectedItemKey"
    >
      <kf-rich-text>
        <!-- eslint-disable-next-line vue/no-v-html -->
        <div v-html="item.answer" />
      </kf-rich-text>
    </kf-accordion-item>
  </section>
</template>

<script>
import KfAccordionItem from '@/components/accordion/AccordionItem.vue';
import KfRichText from '@/components/base/rich-text/RichText.vue';
import Utils from '@/lib/utils';

export default {
  name: 'KfAccordion',
  components: {
    KfAccordionItem,
    KfRichText,
  },
  props: {
    accordionItems: {
      type: Array,
      default: () => [],
    },
    accordionTitle: {
      type: String,
      default: '',
    },
    accordionIntro: {
      type: String,
      default: '',
    },
    accordionTitleLink: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      preselectedItemKey: Utils.queryString.getParameter('selected') || (typeof window !== 'undefined' && window.location?.hash?.replace('#', '')),
    };
  },
  mounted() {
    if (
      this.preselectedItemKey &&
      typeof window !== 'undefined' &&
      typeof document !== 'undefined'
    ) {
      const $el = document.getElementById(this.preselectedItemKey);
      if ($el) {
        $el.scrollIntoView({ behavior: 'smooth' });
      }
    }
  },
};
</script>

<style lang="postcss">
.accordion {
  &-intro {
    @apply mb-8;
  }

  &__filters {
    @apply flex p-0 mb-4 gap-2 flex-wrap;

    .accordion-listitem {
      @apply list-none;

      &-btn {
        @apply border-2 border-black rounded-md bg-white px-4 py-1;

        &.is-active {
          @apply bg-primary-bravo text-white;
        }
      }
    }
  }

  &__title {
    @apply relative mb-0 pr-12 list-none font-bold text-lg cursor-pointer outline-none text-primary-bravo py-4 border-b border-gray-50;
    transition: color 150ms ease-out;

    &::-webkit-details-marker {
      @apply hidden;
    }

    &::before {
      content: '';
      @apply block absolute top-0 right-0 bottom-0 m-auto;
      top: 5px;
      width: 14px;
      height: 9px;
      background-image: url('~@/assets/svg/chevron-down.svg?inline');
      background-repeat: no-repeat;
      background-size: contain;
      transition: transform 150ms ease-out;
    }

    .theme-secondary & {
      &::before {
        background-image: url('~@/assets/svg/theme-secondary/ts-chevron-down.svg?inline');
      }
    }

    &:hover {
      @apply text-black;
    }
  }

  &__button {
    @apply w-full text-left;
  }

  &__wrapper {
    @apply relative;
  }

  &__content {
    @apply pr-8 overflow-hidden h-auto max-h-0;

    ul {
      @apply mb-6;
    }
  }

  .is-open {
    .accordion__title {
      @apply text-black border-0;

      &::before {
        transform: rotate(180deg);
      }
    }

    .accordion__content {
      @apply border-b border-gray-50;
      max-height: 999em;

      a[target='_blank'] {
        background-image: url('~@/assets/svg/external-link-pink.svg?inline');
        background-repeat: no-repeat;
        background-position: right;
        background-size: 12px 12px;
        padding-right: 16px;
      }

      .theme-secondary & {
        a[target='_blank'] {
          background-image: url('~@/assets/svg/theme-secondary/ts-external-link-pink.svg?inline');
        }
      }
    }
  }

  /* .fade-switch-enter-active,
  .fade-switch-leave-active {
    transition: all 50ms;
  } */

  .fade-switch-enter,
  .fade-switch-leave-to {
    opacity: 0;
    position: absolute;
    transform: translateY(30px);
  }
}
</style>
